import { render } from "./AccountDataContainer.vue?vue&type=template&id=f3b12624"
import script from "./AccountDataContainer.vue?vue&type=script&lang=js"
export * from "./AccountDataContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__